<template>
  <div id="app">
     <div class="language">
<!-- <el-select v-model="$i18n.locale" @change="changeLanguage">
      <el-option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
        {{ lang }}
      </el-option>
    </el-select> -->
    </div> 
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      langs:['en','cn']
    }
  },
  created () {
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    try{
    var lan=window.localStorage.getItem('lang')||'cn'
    this.$i18n.locale=lan
    }catch(e){

    }
  },
  mounted () {
    
  },
  methods:{
    changeLanguage(val){
      window.localStorage.setItem('lang',val)
      console.log(val);
    }
  }
}
</script>

<style scoped>
.language{
  position: absolute;
  top: 5px;
  right: 10%;
  color: aliceblue;
  z-index: 150;
}

</style>



// WEBPACK FOOTER //
// src/App.vue